import PublicRoute from "./PublicRoute";
import ProtectedRoute from "./ProtectedRoute";
import { Route, Routes } from "react-router-dom";

import { Dashboard } from "@pages/auth/Dashboard";
import { Land } from "@pages/public/Land";
import { Auth } from "@pages/public/Auth";
import { ContactUs } from "@pages/public/ContactUs";
import PublicLayout from "@components/layout/PublicLayout";
import { CampaignDefaultList } from "@pages/auth/raffles/default/DefaultList";
import { DefaultRaffleVisit } from "@pages/auth/raffles/default/DefaultRaffleVisit";
import { RaffleTicketCheckout } from "@pages/auth/raffles/CheckOut";
import { MyOrders } from "@pages/auth/raffles/MyOrders";
import { Financial } from "@pages/auth/financial/Financial";
import { MyTickets } from "@pages/auth/tickets/MyTickets";
import { MyRewards } from "@pages/auth/rewards/MyRewards";
import { MyRewardDetail } from "@pages/auth/rewards/detail/MyRewardDetail";

export default function AppRoutes() {
  return (
    <>
      <Routes>
        {/* Public Routes with PublicRoute wrapper */}
        <Route element={<PublicRoute />}>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Land />} />
            <Route path="/login" element={<Auth />} />
            <Route path="/contact-us" element={<ContactUs />} />

            {/* Raffle | Campaign */}
            <Route
              path="/campaign/default/list"
              element={<CampaignDefaultList />}
            />
            <Route path="/campaign/default" element={<DefaultRaffleVisit />} />

            {/* My Tickets */}
            <Route path="/my-tickets" element={<MyTickets />} />

            {/* My Rewards */}
            <Route path="/my-rewards" element={<MyRewards />} />
            <Route path="/my-rewards/detail" element={<MyRewardDetail />} />

            {/* Financial */}
            <Route path="/financial" element={<Financial />} />

            {/* Legacy Financial Route */}
            <Route path="/order/list" element={<MyOrders />} />

            {/* Raffle | CheckOut */}
            <Route path="/raffle/checkout" element={<RaffleTicketCheckout />} />
          </Route>
        </Route>

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/dashboard" element={<Dashboard />} />
        </Route>
      </Routes>
    </>
  );
}
